import { Eyebrow, Reveal } from "../landing/shared";

const STAGES = [
    {
        title: "Understand",
        copy: "We understand your workforce requirements, roles and candidate criteria.",
    },
    {
        title: "Source",
        copy: "We identify suitable talent from relevant markets.",
    },
    {
        title: "Screen",
        copy: "Candidates are assessed against the requirements provided.",
    },
    {
        title: "Shortlist",
        copy: "Suitable candidates are shortlisted for employer consideration.",
    },
    {
        title: "Select",
        copy: "The employer conducts the appropriate interview and selection process.",
    },
    {
        title: "Mobilize",
        copy: "Applicable documentation and mobility processes are coordinated toward deployment.",
    },
];

export const ProcessTimeline = () => (
    <section data-testid="employer-process-section" className="bg-night py-24 text-ivory lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
                <Reveal className="lg:col-span-7">
                    <Eyebrow dark>Our Process</Eyebrow>
                    <h2 className="mt-5 max-w-xl font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
                        A Clear Path From Requirement to Talent
                    </h2>
                </Reveal>
                <Reveal delay={0.1} className="lg:col-span-5">
                    <p className="max-w-md text-base leading-relaxed text-ivory/65">
                        Six structured stages — so you always know where your recruitment stands and what
                        happens next.
                    </p>
                </Reveal>
            </div>

            <Reveal className="mt-16 lg:mt-24">
                <div className="relative">
                    <div
                        className="absolute inset-x-0 top-[5px] hidden h-px bg-ivory/15 xl:block"
                        aria-hidden="true"
                    />
                    <ol className="grid gap-y-12 sm:grid-cols-2 xl:grid-cols-6 xl:gap-x-10">
                        {STAGES.map((stage, i) => (
                            <li
                                key={stage.title}
                                data-testid={`process-step-${i + 1}`}
                                className="relative border-l border-ivory/15 pl-6 xl:border-l-0 xl:pl-0 xl:pt-9"
                            >
                                <span
                                    className="absolute -left-[5px] top-[3px] h-2.5 w-2.5 rotate-45 bg-champagne xl:left-0 xl:top-0"
                                    aria-hidden="true"
                                />
                                <span className="font-serif text-4xl font-medium text-ivory/25">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <h3 className="mt-4 text-base font-semibold uppercase tracking-[0.14em] text-ivory">
                                    {stage.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-ivory/60">{stage.copy}</p>
                            </li>
                        ))}
                    </ol>
                </div>
            </Reveal>
        </div>
    </section>
);
